const form = {
  formId: "assign-role",
  formField: {
    role: {
      name: "role",
      label: "role",
      type: "select",
      options: [],
      errorMsg: "Role is required.",
      placeholder: "Role"
    }
  }
};

export default form;
